import React from 'react'

import './Logo.css'

const Logo = ({ inverted }) => (
  <div
    className="Logo"
    style={{
      backgroundImage: 'url(/images/logo.svg)',
    }}
  />
)

export default Logo
